var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconItems(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-6 h-6",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m13.03336,11.48533c2.88934,-2.66802 1.28073,-8.13318 -4.20594,-8.19363c-5.48667,-0.06045 -7.21438,4.84606 -7.11129,8.6305c0.10309,3.78444 2.97707,8.6287 9.51395,8.59591l10.87263,0.04098l0,-8.98359l-12.02868,-0.0041c-1.44467,0.01981 -3.62704,0.08061 -3.63729,-1.90778c0.00854,-1.71823 0.67281,-2.45287 1.95184,-2.49078c1.0058,0.01674 1.80669,0.85314 1.78792,2.26332"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 20.70487,
    x2: 18.35245,
    y1: 15.13111,
    x1: 18.31146
  }), /*#__PURE__*/React.createElement("line", {
    y2: 20.66388,
    x2: 14.5,
    y1: 15.09012,
    x1: 14.45901
  }), /*#__PURE__*/React.createElement("line", {
    y2: 20.70487,
    x2: 10.56557,
    y1: 15.13111,
    x1: 10.52459
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconItems);
export default __webpack_public_path__ + "static/media/icon-items.3118fe78.svg";
export { ForwardRef as ReactComponent };